import { useSelector } from 'react-redux';
import type { DealsState } from './types';
import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';

export const useDealsSelector = (): DealsState => {
    const salesCheckin: DealsState = useSelector((state: SalesCheckinRootState) => state.salesCheckin.deals || {});
    return salesCheckin;
};
